// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Common - Start **/
.BannerCaption-noPadding-iLR2M {
    padding: 0px;
}
.BannerCaption-noMargin-i23iq {
    margin: 0px;
}
/** Common - End **/
/** Banner caption - Start **/
.BannerCaption-bannerCaptionContainer-YcORZ {
    position: relative;
}
.BannerCaption-bannerCaptionText-wN0Sy {
    font-size: 48px;
    line-height: 56px;
    color: var(--common-text-color);
    margin-bottom: 18px;
    text-align: center;
}
.BannerCaption-bannerCaptionHighlight-G1obz {
    font-weight: 700;
    color: var(--btn-primary-bg);
}
.BannerCaption-bannerCaptionPara-Xydr2 {
    font-size: 18px;
    line-height: 26px;
    color: var(--common-text-color);
    margin: 0px;
    font-weight: 500;
    text-align: center;
}
@media (max-width:1199px) and (min-width:768px) {
    .BannerCaption-bannerCaptionContainer-YcORZ {
        padding-top: 50px;
    }
}
@media screen and (max-width: 767px) {
    .BannerCaption-bannerCaptionText-wN0Sy {
        font-size: 25px;
        line-height: 30px;
    }

    .BannerCaption-bannerCaptionContainer-YcORZ {
        padding-top: 50px;
    }
}
/** Banner caption - End **/`, "",{"version":3,"sources":["webpack://./src/components/Home/BannerCaption/BannerCaption.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,YAAY;AAChB;AAEA;IACI,WAAW;AACf;AAEA,mBAAmB;AAEnB,6BAA6B;AAC7B;IACI,kBAAkB;AACtB;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;AAEA,2BAA2B","sourcesContent":["/** Common - Start **/\n.noPadding {\n    padding: 0px;\n}\n\n.noMargin {\n    margin: 0px;\n}\n\n/** Common - End **/\n\n/** Banner caption - Start **/\n.bannerCaptionContainer {\n    position: relative;\n}\n\n.bannerCaptionText {\n    font-size: 48px;\n    line-height: 56px;\n    color: var(--common-text-color);\n    margin-bottom: 18px;\n    text-align: center;\n}\n\n.bannerCaptionHighlight {\n    font-weight: 700;\n    color: var(--btn-primary-bg);\n}\n\n.bannerCaptionPara {\n    font-size: 18px;\n    line-height: 26px;\n    color: var(--common-text-color);\n    margin: 0px;\n    font-weight: 500;\n    text-align: center;\n}\n\n@media (max-width:1199px) and (min-width:768px) {\n    .bannerCaptionContainer {\n        padding-top: 50px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .bannerCaptionText {\n        font-size: 25px;\n        line-height: 30px;\n    }\n\n    .bannerCaptionContainer {\n        padding-top: 50px;\n    }\n}\n\n/** Banner caption - End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noPadding": `BannerCaption-noPadding-iLR2M`,
	"noMargin": `BannerCaption-noMargin-i23iq`,
	"bannerCaptionContainer": `BannerCaption-bannerCaptionContainer-YcORZ`,
	"bannerCaptionText": `BannerCaption-bannerCaptionText-wN0Sy`,
	"bannerCaptionHighlight": `BannerCaption-bannerCaptionHighlight-G1obz`,
	"bannerCaptionPara": `BannerCaption-bannerCaptionPara-Xydr2`
};
module.exports = ___CSS_LOADER_EXPORT___;
